import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const studentValidationGroupSchema = t => ({
  userId: yup.number().required(t(translations.validation.required())),
  groupId: yup.number().required(t(translations.validation.required()))
});

export const studentValidationEventSchema = t => ({
  userId: yup.number().required(t(translations.validation.required()))
});

export const studentInitialValues = () => {
  return { userId: '', groupId: '' };
};
